/*
 * @Author: liujunhong
 * @Date: 2023/2/20
 * @Desc: 页面成功跳转
 */

import React, { FC, useEffect, useRef, useState } from 'react';
import styles from './style.module.less';
import { useNavigate } from 'react-router-dom';
// 时间间隔
export const DURATION = 1000;

interface Props {
  href: string;
  id: string;
  title: string;
  jumpText: string;
  time?: number;
  description?: string;
}

const useTimeDown = (href: string, time = 5) => {
  const navigate = useNavigate();
  const [clock, setClock] = useState(time);
  const intervalRef = useRef<any>(null);

  const handleJump = () => {
    navigate(href);
    reset();
  };

  const reset = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  const countDown = () => {
    let t = clock;
    intervalRef.current = setInterval(() => {
      if (0 < t) {
        t--;
        setClock(t);
      } else {
        handleJump();
      }
    }, DURATION);
  };

  useEffect(() => {
    countDown();
    return () => {
      reset();
    };
  }, []);

  return {clock, handleJump};
};

const Index: FC<Props> = props => {
  const {href, id, title, jumpText, description, time = 5} = props;
  const {clock, handleJump} = useTimeDown(href, time);

  return <>
    {!!clock && <div className={styles.success_tips_wrap}>
      <p className={styles.success_tips_title} id={id}>{title}</p>
      {description && <p className={styles.success_tips_description}>{description}</p>}
      <p className={styles.success_tips_jump}>{clock}秒钟后跳转至{jumpText}...... <span
        onClick={() => handleJump()}>立即跳转</span>
      </p>
    </div>}
  </>;
};
export default Index;
